import React from "react";
import {Button} from "@contentful/f36-components";
import PoweredBy from "../PoweredBy";

export const LandingPage = ({ onNewTranslation }) => {

    return (
        <>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '24px'}}>
                <div style={{width: '180px', marginBottom: '10px'}}>
                    <img src="./images/Soffione.svg" alt="Soffione"/>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div>Translate your content into</div>
                    <div>200+ languages</div>
                </div>
            </div>
            <Button style={{marginTop: '24px'}} variant="primary" isFullWidth onClick={onNewTranslation}>New translation order</Button>
            <PoweredBy/>
        </>
    )
}